export default __webpack_public_path__ + "static/media/78_RGB.0ff49033.webp";